import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import axios from "axios";
import { baseUrl } from "../Common/data";
import Select from "react-select";

function Ticket({ ticketModel, toggleModel }) {
  // State management
  const [ticketType, setTicketType] = useState("");
  const [issue, setIssue] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false); // Loader state
  const [allHotels, setAllHotels] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState([]);
  const [selectedHotelId, setSelectedHotelId] = useState("");
  const hotelOptions =
    allHotels &&
    allHotels.length > 0 &&
    allHotels.map((hotel) => ({
      value: hotel._id,
      label: hotel.propertyName
    }));

  // Options for the dropdowns
  const options = {
    "Problem regarding property Owner": [
      "No response on inquiries/call",
      "Incorrect contact number of owner",
      "Owner not agreeing to the listed price",
      "Availability issue",
      "Others"
    ],
    "Problems regarding property": [
      "Misleading/fake photos",
      "Property details not as listed",
      "Issues regarding services [ meals, pool, hygiene issues ]",
      "Inappropriate behavior from owner/staff",
      "Services not up to mark",
      "Others"
    ],
    "Other Issues": ["Other Issues (Please specify)"]
  };

  const fetchAllHotels = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/hotel/ticket/all`);
      if (response.status === 200) {
        const hotels = response.data.data || [];
        setAllHotels(hotels);
        setFilteredHotels(hotels);
      } else {
        console.error("Failed to fetch hotels:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching hotels:", error);
    }
  };

  useEffect(() => {
    fetchAllHotels();
  }, []);

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("LOGIN IS REQUIRED TO SEND AN ENQUIRY");
      return;
    }

    if (!ticketType || !issue || !description || !selectedHotelId) {
      alert("Please fill out all fields before submitting the ticket.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/ticket-user/add`,
        {
          ticketType,
          issue,
          description,
          hotelId: selectedHotelId
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.status === 200) {
        alert("Ticket is submitted.");
        toggleModel(false);
      }
    } catch (error) {
      console.error("Error submitting ticket:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    return () => {
      setTicketType("");
      setIssue("");
      setDescription("");
      setSelectedHotelId("");
    };
  }, []);

  return (
    <Modal
      size="md"
      toggle={() => toggleModel(!ticketModel)}
      isOpen={ticketModel} 
      style={{zIndex:'100000'}}
    >
      <ModalHeader toggle={() => toggleModel(!ticketModel)}>
        Submit Ticket
      </ModalHeader>
      <ModalBody>
        <div className="modal-div">
          <label htmlFor="hotelSelect">Search & Select Hotel</label>
          <Select
            id="hotelSelect"
            options={hotelOptions}
            value={
              hotelOptions &&
              hotelOptions.length > 0 &&
              hotelOptions.find((option) => option.value === selectedHotelId)
            }
            onChange={(selectedOption) =>
              setSelectedHotelId(selectedOption?.value || "")
            }
            placeholder="Search and select a hotel..."
            isClearable
          />

          {/* Submit Button */}
          <br />
          {/* Ticket Type Dropdown */}
          <label htmlFor="ticketType">Select Issue Type</label>
          <select
            id="ticketType"
            value={ticketType}
            onChange={(e) => {
              setTicketType(e.target.value);
              setIssue("");
            }}
          >
            <option value="">-- Select Issue Type --</option>
            {Object.keys(options).map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>

          {/* Issue Dropdown */}
          {ticketType && (
            <>
              <label htmlFor="issue">Select Specific Issue</label>
              <select
                id="issue"
                value={issue}
                onChange={(e) => setIssue(e.target.value)}
              >
                <option value="">-- Select Specific Issue --</option>
                {options[ticketType].map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </>
          )}

          {/* Description Field */}
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            placeholder="Enter a brief description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows="4"
            style={{ padding: "10px", borderRadius: "15px" }}
          />
          <br />
          {/* Hotel Search and Select */}
          <button onClick={handleSubmit} disabled={loading}>
            {loading ? "Submitting..." : "Submit Ticket"}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default Ticket;
